export const hotelRegulationsText = {
    "en-US": `
<b>Dear Guest,</b>
We’re thrilled to have you stay with us at cozy Self Check-in Rooms, where we strive to create a cozy, fun, and safe environment for all our guests. To help us maintain this atmosphere, we kindly ask that you follow the house rules outlined below. These guidelines ensure everyone’s comfort, safety, and enjoyment, while also helping us preserve the quality of our property.

<b>1. Security Deposit</b>
A security deposit of 150 CHF is required for every reservation. This deposit will be held on your credit card and released within one week after checkout, provided there are no damages or issues.

<b>2. Self-Check-In</b>
The cozy Self Check-in Rooms operates with a self-check-in system. To access your room, please complete the Self-Check-In Form sent with your booking confirmation and ensure that your payment is processed. We are not responsible for any access issues if these steps are not completed.

<b>3. Communication & Services</b>
All communication, except in emergencies, should be conducted through our guest portal or by WhatsApp. Rooms are cleaned and prepared before your arrival, but the room rate does not include cleaning services during your stay.

<b>4. No Parties or Events</b>
The cozy Self Check-in Rooms is a social yet peaceful place. Parties and events that cause noise or disturbances are strictly prohibited to maintain a pleasant environment for all guests.

<b>5. No Smoking</b>
Smoking is prohibited indoors. Please use designated outdoor smoking areas and dispose of cigarette butts responsibly.

<b>6. Pets</b>
Pets are not allowed at cozy Self Check-in Rooms.

<b>7. Found Items</b>
If you leave anything behind, it will be kept in our lost and found. Please contact us to arrange a collection, as our office may not always be open.

<b>8. No Unregistered Guests</b>
For security and comfort, only guests listed in the booking are allowed on the premises.

<b>9. Quiet Hours</b>
To ensure a restful environment, quiet hours are from 10:00 PM to 7:00 AM and from 12:00 PM to 1:00 PM. Sundays and public holidays are also considered quiet times.

<b>10. Check-In and Check-Out Times</b>
Please respect our check-in and check-out times to help us manage cleaning schedules and prepare for incoming guests. Check-in time is earliest by 16:00 (4:00 pm)  and check-out time latest by 11:00 am.

<b>11. Key Care</b>
Please take care of your room key. Lost keys will incur a replacement fee of 200 CHF.

<b>12. Respect for Furniture and Property</b>
Treat the property with care and report any damages. If damages exceed the security deposit, additional charges will apply.

<b>13. No Rearranging Furniture</b>
Please do not move or rearrange furniture, as this can cause damage and create extra work for our team.

<b>14. Trash Disposal</b>
Please take out your trash before checking out to keep the hotel tidy.

<b>15. No Illegal Substances</b>
The use or possession of illegal substances is strictly forbidden to ensure a safe and legal environment for all guests.

<b>16. No Prostitution</b>
Prostitution is strictly prohibited at cozy Self Check-in Rooms. Violation of this rule will result in a 1000 CHF fine and a report to the authorities.

<b>17. Babies are allowed</b>
Babies are welcome; however, we do not provide baby cots, high chairs, strollers, or any other baby equipment.

By following these rules, you’re helping us keep cozy Self Check-in Rooms a welcoming, enjoyable, and safe place for everyone. We appreciate your cooperation and hope you have a fantastic stay!

<b>Warm regards,
cozy Self Check-in Rooms Team</b>
`};
